module.exports = "../../app/cells/pages/bifrost/study_guide/menu_bar_float_cell.rb";